import axios from 'axios';

const pseudoAxiosInstance = axios.create();
function getRequestUrlFromRemote(remote, params) {
  if (isRemoteWithExtraConfigUrlAtExtra(remote)) {
    if (params === void 0) {
      throw new Error("remote \uC694\uCCAD \uD30C\uB77C\uBBF8\uD130\uAC00 \uB204\uB77D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
    }
    return remote(pseudoAxiosInstance)[2](params).url;
  }
  return remote(pseudoAxiosInstance)[1].url;
}
function isRemoteWithExtraConfigUrlAtDefault(remote) {
  const [, defaultConfig, extraConfigGenerator] = remote(pseudoAxiosInstance);
  return extraConfigGenerator !== void 0 && "url" in defaultConfig;
}
function isRemoteWithExtraConfigUrlAtExtra(remote) {
  const [, , extraConfigGenerator] = remote(pseudoAxiosInstance);
  return extraConfigGenerator !== void 0 && !isRemoteWithExtraConfigUrlAtDefault(remote);
}

export { getRequestUrlFromRemote };
//# sourceMappingURL=utils.mjs.map
